import { Card, CardContent, Typography } from "@mui/material";
import { Title, useGetList } from "react-admin";
import { Grid } from "@mui/material";
import "./Dashboard.css";
const StatCard = ({ title, value }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent>
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h4" fontWeight={600}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);
 
const Dashboard = () => {
  const { data, isLoading } = useGetList("users", {
    pagination: { page: 1, perPage: 100 },
  });
 
  if (isLoading) return null;
 
  const totalUsers = data.length;
  const admins = data.filter((u) => u.role === "admin").length;
  const activeUsers = data.filter((u) => u.is_active).length;
 
  return (
  <>
  <Title>Dashboard</Title>
  <h3>
       Welcome to Dashboard
    </h3>
    <div className="details">
     
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <StatCard title="Total Users" value={totalUsers} />
      </Grid>
 
      <Grid item xs={12} sm={6} md={4}>
        <StatCard title="Active Users" value={activeUsers} />
      </Grid>
 
      <Grid item xs={12} sm={6} md={4}>
        <StatCard title="Admins" value={admins} />
      </Grid>
    </Grid>
    </div>
    </>
  );
};
 
export default Dashboard;
 
 